import TITAN_LOGO_GREEN from "@/assets/branding/titanhq-logo-green.svg";

function normalizeLogo(logo) {
  if (!logo || typeof logo !== "string") return "";
  const v = logo.trim();
  const lower = v.toLowerCase();
  if (!v || lower === "null" || lower === "undefined") return "";
  return logo;
}

const state = {
  logo: null,
  title: null,
  mspLogo: "",
  interface: {
    nameservers: [],
    system: {},
  },
};

const getters = {
  uiLogo: (state) => state.logo,
  uiTitle: (state) => state.title,
  interface: (state) => state.interface,
  mspInterfaceLogo: (state) => state.mspLogo,
};
const actions = {
  // TODO: move this to the batch endpoint
  // eslint-disable-next-line no-unused-vars
  async fetchInterface({ commit }, { mspId = null }) {
    let getCurrentUI = this._vm.$userPrefs.getCurrentUi();
    const defaultTitle = "WebTitan";

    // Default values:
    let logo = getCurrentUI.logo || TITAN_LOGO_GREEN;
    let title = getCurrentUI.title || defaultTitle; //"TitanHQ"

    // Override from server:
    let restapiEndpoint = "/restapi/ui/interface?own=true";
    if (mspId) {
      restapiEndpoint = "/restapi/ui/interface?own=false&msp_id=" + mspId;
    }
    const response = await this._vm.$http.get(restapiEndpoint);
    const apiLogo = normalizeLogo(response.data.logo);
    if (apiLogo) logo = apiLogo;
    if (response.data.title) title = response.data.title;
    //! when title is deleted from API, the default title should be set here, because API doesn't handle default title from API:
    if (response.data.title == null) title = defaultTitle;
    // Set the UI elements:
    if (apiLogo) commit("setMspInterfaceLogo", apiLogo);
    else commit("deleteMspInterfaceLogo");
    commit("setInterfaceLogo", apiLogo || null);
    this._vm.$userPrefs.updateUserPrefs({
      ui: { logo, title },
    });
    return response.data;
  },

  async fetchInterfaceBatch({ commit }) {
    let response = await this._vm.$http.post(`/restapi/batch`, {
      // TODO: Enable when the API returns the correct info
      // nameservers: {
      //   method: `GET`,
      //   path: `/ui/dns`,
      // },
      system: {
        method: `GET`,
        path: `/ui/system`,
      },
    });

    // // Filter only "dns" records for the nameservers from the response:
    // let tmp_nameservers = Object.fromEntries(
    //   Object.entries(response.data.nameservers.response).filter(([key]) =>
    //     key.toLowerCase().includes("dns")
    //   )
    // );
    // // Filter and override the response nameservers with only existing ones:
    // response.data.nameservers = Object.values(tmp_nameservers).filter(
    //   (val) => val
    // );

    response.data.system = response.data.system.response;

    commit("setUserInterface", response);
  },

  async updateInterface({ commit }, { body }) {
    let getCurrentUI = this._vm.$userPrefs.getCurrentUi();
    let logo = getCurrentUI.logo;
    let title = getCurrentUI.title;

    const response = await this._vm.$http.post("/restapi/ui/interface", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const apiLogo = normalizeLogo(response.data.logo);
    if (apiLogo) logo = apiLogo;
    if (response.data.title) title = response.data.title;

    // Set the UI elements:
    commit("setInterfaceLogo", logo || null);
    commit("setInterfaceTitle", title);
    if (apiLogo) commit("setMspInterfaceLogo", apiLogo);
    else commit("deleteMspInterfaceLogo");
    this._vm.$userPrefs.updateUserPrefs({
      ui: { logo, title },
    });
    return response.data;
  },

  async deleteInterfaceLogo({ commit }) {
    await this._vm.$http.delete(`/restapi/ui/interface/logo`);
    commit("deleteInterfaceLogo");
    commit("deleteMspInterfaceLogo");
  },

  async deleteInterfaceTitle({ commit }) {
    await this._vm.$http.delete(`/restapi/ui/interface/title`);
    commit("deleteInterfaceTitle");
    commit("deleteMspInterfaceLogo");
  },
};

const mutations = {
  deleteInterfaceLogo: (state) => (state.logo = null),
  deleteInterfaceTitle: (state) => (state.title = null),
  setInterfaceLogo: (state, data) => (state.logo = data),
  setInterfaceTitle: (state, data) => (state.title = data.title),
  setUserInterface: (state, data) => (state.interface = data.data),
  setMspInterfaceLogo: (state, data) => (state.mspLogo = data),
  deleteMspInterfaceLogo: (state) => (state.mspLogo = ""),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
